<template>
  <validation-observer
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="type-of-use"
      v-bind="observer"
      :validated="formObserver.validated"
    >
      <!-- TYPE OF USE GENERIC -->
      <form-row label="What will you use the car for?">
        <template #helpText>
          <show-more
            open-text="Why does this matter?"
            hide-text="Why does this matter?"
          >
            <p>Insurers look at how you and the named drivers on the policy use your car to work out how much risk there is in insuring it.</p>
          </show-more>
        </template>
        <validation-provider
          v-slot="{ failed }"
          :vid="`${stepId}_type-of-use`"
          name="Type of Use"
          :rules="{ is_not: { other: null } }"
        >
          <radio
            v-model="vehicleTypeOfUseModel"
            name="type-of-use"
            :data-test="snakeCase(questionFields.typeOfUse)"
            :items="vehicleTypeOfUseGenericOptions"
            :error="failed"
            column
            return-object
          />
        </validation-provider>
      </form-row>
      <!-- TYPE OF USE BUSINESS -->
      <form-row
        v-if="isTypeOfUseBusiness"
        gap="16"
      >
        <validation-provider
          v-slot="{ failed }"
          :vid="`${stepId}_type-of-use`"
          name="Type of Use (Business)"
          rules="required"
        >
          <qz-select
            v-model="questionData.typeOfUse"
            :data-test="`${snakeCase(questionFields.typeOfUse)}_other`"
            :items="vehicleTypeOfUseBusinessOptions"
            :placeholder="helpers.getPlaceholderResponsiveText('Please select type of use', isMobile)"
            :error-messages="failed ? ['Please also select the type of business use from this list.'] : []"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';

import { createOptions } from '@/helpers/common';

import {
  omit,
  pick,
} from 'lodash';

export default {
  name: 'question-type-of-use',
  extends: QuestionBase,
  data () {
    return { fields: ['typeOfUse'] };
  },
  computed: {
    isMobile () { return this.$vuetify.breakpoint.smAndDown; },
    vehicleTypeOfUseGenericOptions () {
      return [
        ...createOptions({
          source: pick(this.constants.VEHICLE_TYPE_OF_USE, this.constants.VEHICLE_TYPE_OF_USE_FAVORITES),
          asNumbers: true,
        }),
        {
          value: true,
          text: this.constants.VEHICLE_TYPE_OF_USE_OTHER,
          logical: true,
          logicalValue: '',
        },
      ];
    },
    vehicleTypeOfUseBusinessOptions () {
      return createOptions({
        source: omit(this.constants.VEHICLE_TYPE_OF_USE, this.constants.VEHICLE_TYPE_OF_USE_FAVORITES),
        asNumbers: true,
      });
    },

    vehicleTypeOfUseModel: {
      get () {
        if (this.questionData.typeOfUse === null) return null;
        return this.constants.VEHICLE_TYPE_OF_USE_FAVORITES.includes(this.questionData.typeOfUse) ? this.questionData.typeOfUse : true;
      },
      set (val) {
        this.questionData.typeOfUse = val.logical ? val.logicalValue : val.value;
      },
    },

    isTypeOfUseBusiness () {
      return this.vehicleTypeOfUseModel !== null && !this.constants.VEHICLE_TYPE_OF_USE_FAVORITES.includes(this.vehicleTypeOfUseModel);
    },
  },
};
</script>
